import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@mui/material'
import homeCarInsurance from 'src/assets/Buy_Policy_Images/homeCarInsurance.svg'
import rentalVehicle from 'src/assets/Buy_Policy_Images/rentalVehicle.svg'
import trovityLogo from 'src/assets/Buy_Policy_Images/TrovityImage.svg'
import trustedAdvisor from 'src/assets/Buy_Policy_Images/trustedAdvisor.svg'

const TrovityContent = () => {
  const classes = useStyles()
  return (
    <>
      <Box className={classes.componentBackground}>
        <Box className={classes.componentElement}>
          <Box className={classes.advisorContentTop}>
            <Box className={classes.imageContainerMain}>
              <Box className={classes.overLappingImagesSection}>
                <Box>
                  <img
                    src={trovityLogo}
                    alt='trovity-logo'
                    className={classes.trovityImageContainer}
                  />
                </Box>
                <Box>
                  <img
                    src={trustedAdvisor}
                    alt='trusted advisor'
                    className={classes.trustedAdvisorImg}
                  />
                </Box>
              </Box>
              <Box>
                <img
                  src={rentalVehicle}
                  alt='trusted-advisor'
                  className={classes.imageContainer}
                />
              </Box>
            </Box>
            <Box className={classes.advisorTextSection}>
              <Box className={classes.advisorText}>
                Welcome to Trovity, your trusted insurance advisor for all your
                car insurance needs.
              </Box>
              <hr />

              <Box className={classes.advisorText}>
                We understand the importance of protecting your car, and
                that&apos;s why we are here to guide you.
              </Box>
              <hr />
              <Box className={classes.advisorTextLast}>
                We go through the process of finding the perfect car insurance
                solution.
              </Box>
            </Box>
          </Box>
          <Box className={classes.advisorContentBottom}>
            <Box className={classes.insuranceContent}>
              <Box>
                <Box className={classes.questionTextBold}>
                  What is the necessity{' '}
                </Box>
                <Box className={classes.questionText}>
                  for having Car Insurance?
                </Box>
              </Box>
              <Box className={classes.insuranceCoverText}>
                Car insurance provides financial protection to car owners
                against potential losses related to their vehicles. It covers
                accidents, theft, natural disasters, and other unforeseen
                events.
              </Box>
              <Box className={classes.insuranceText}>
                When you purchase car insurance, you pay a premium, and the
                insurer agrees to cover specific damages or losses as outlined
                in the policy. It typically includes liability, collision,
                comprehensive, and uninsured/underinsured motorist coverage.{' '}
              </Box>
              <Box className={classes.insuranceText}>
                Car insurance is mandatory in most countries to ensure drivers
                have at least a minimum level of coverage. Understanding your
                policy is crucial for peace of mind on the roads.
              </Box>
            </Box>
            <Box>
              <img
                src={homeCarInsurance}
                className={classes.homeCarInsuranceImage}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}
export default TrovityContent
const useStyles = makeStyles({
  componentElement: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    paddingBottom: '15px',
    background: `
    linear-gradient(180deg, #D9D9D9 0%, #FFFFFF 30%),
    linear-gradient(180deg, #F3F3F3 15.93%, rgba(255, 255, 255, 0) 50.35%)`,
  },
  componentBackground: {
    background: `
    linear-gradient(180deg, #D9D9D9 0%, #FFFFFF 30%),
    linear-gradient(180deg, #F3F3F3 15.93%, rgba(255, 255, 255, 0) 96.35%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  overallContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    paddingBottom: '10px',
    background: `
    linear-gradient(180deg, #D9D9D9 0%, #FFFFFF 100%),
    linear-gradient(180deg, #F3F3F3 15.93%, rgba(255, 255, 255, 0) 96.35%)`,
  },
  questionTextBold: {
    fontFamily: 'Roboto',
    fontSize: '30px',
    fontWeight: '600',
    lineHeight: '35.16px',
    color: '#B92250',
  },
  questionText: {
    fontFamily: 'Roboto',
    fontSize: '22px',
    fontWeight: '300',
    lineHeight: '25.78px',
    color: '#B92250',
  },
  advisorText: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: '400',
    lineHeight: '22px',
    color: '#3B3B3B',
    padding: '0px 0px 16px 0px',
    borderBottom: '1px solid #EF669B',
  },
  advisorTextLast: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: '400',
    lineHeight: '22px',
    color: '#3B3B3B',
    padding: '0px 0px 16px 0px',
  },
  insuranceText: {
    fontFamily: 'Roboto',
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '22px',
    color: '#4A4A4A',
  },
  insuranceCoverText: {
    fontFamily: 'Roboto',
    fontSize: '19px',
    fontWeight: '300',
    lineHeight: '22px',
    color: '#2C2C2C',
  },
  insuranceContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    maxWidth: '550px',
  },
  advisorContentTop: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 40,
    padding: '80px 40px',
  },
  advisorContentBottom: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 40,
    padding: '0px 45px 0px 45px',
    borderTop: '1px solid',
    borderColor: '#D6D6D6',
    borderBottom: '1px solid #D6D6D6',
  },
  advisorTextSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '400px',
    paddingTop: '20px',
  },
  divider: {
    color: '#EF669B !important',
  },
  trocityCarInsuranceImage: {
    position: 'absolute',
    top: '845px',
    left: '393px',
    zIndex: 1,
    height: '99px',
    width: '427px',
  },
  imageContainerMain: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    '@media (max-width:800px)': {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 20,
    },
  },
  trovityImageContainer: {
    width: '253.71px',
    height: '41px',
    position: 'absolute',
    top: '144px',
    right: '325px',
    '@media (max-width: 800px)': {
      position: 'unset',
    },
  },
  trustedAdvisorImg: {
    position: 'absolute',
    width: '303px',
    top: 190,
    right: 178,
    '@media (max-width:800px)': {
      position: 'unset',
    },
  },
  overLappingImagesSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 100,
    '@media (max-width:800px)': {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 20,
      position: 'unset',
    },
  },
  imageContainer: {
    maxWidth: '480px',
    maxHeight: '330.1px',
  },
  '@media (max-width: 1200px)': {
    advisorContentTop: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '20px',
      padding: '20px',
      textAlign: 'center',
    },
    advisorContentBottom: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '20px',
      padding: '20px 20px 20px 20px',
      borderTop: '1px solid',
      borderColor: '#D6D6D6',
      textAlign: 'center',
    },
    insuranceContent: {
      width: '100%',
      textAlign: 'center',
    },
  },
  homeCarInsuranceImage: {
    maxWidth: '502.08px',
    maxHeight: '470.47px',
    paddingTop: '40px',
  },
})
